import {
  AfterViewChecked,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import Chart, {ChartPoint, ChartType} from 'chart.js';
import {ChartDataSets, ChartOptions} from 'chart.js';

import {ExcTranslation} from 'exc-core';
import {OverlayConfig} from "exc-controls";

@Component({
  selector: 'app-single-chart',
  templateUrl: './single-chart.component.html',
  styleUrls: ['./single-chart.component.scss']
})
export class SingleChartComponent extends ExcTranslation implements OnInit, AfterViewChecked {
  @Input() chart = null;
  @ViewChild('chartCanvas') chartCanvas: ElementRef;
  private createdChart = null;
  private colors = [
    {f: 'rgba(32, 83, 148, 1)', b: 'rgba(32, 83, 148, 0.4)'},
    {f: 'rgba(250, 169, 51, 1)', b: 'rgba(250, 169, 51, 0.4)'},
    {f: 'rgba(3, 181, 56, 1)', b: 'rgba(3, 181, 56, 0.4)'},
    {f: 'rgba(88, 200, 224, 1)', b: 'rgba(88, 200, 224, 0.4)'},
    {f: 'rgba(181, 3, 154, 1)', b: 'rgba(181, 3, 154, 0.4)'}
  ];

  constructor(private overlayConfig: OverlayConfig) {
    super();
    this.chart = overlayConfig.data;
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked(): void {
    if (!this.createdChart) {
      this.generateChart();
    }
  }

  getTitle() {
    if (!this.chart) {
      return this.getRessource('Loading');
    }
    return this.getRessource(this.chart.Title);
  }

  generateChart() {
    const context = this.chartCanvas.nativeElement.getContext('2d');
    const c = this.chart;
    let colorIndex = 0;
    if (c.datasets.length === 1 && (c.datasets[0].type === 'pie' || c.datasets[0].type === 'doughnut')) {
      if (c.datasets[0].labelTranslated !== true) {
        c.datasets[0].label = this.getRessource(c.datasets[0].label);
        c.datasets[0].labelTranslated = true;
      }
      c.datasets[0].borderWidth = 1;
      c.datasets[0].backgroundColor = [];
      c.datasets[0].borderColor = [];
      for (const a of this.colors) {
        c.datasets[0].backgroundColor.push(a.b);
        c.datasets[0].borderColor.push(a.f);
      }
      for (let l = 0; l < c.labels.length; l++) {
        const nl = this.getRessource(c.labels[l]);
        if (nl !== null && nl !== '' && (nl.indexOf('ChartSliderComponent') === -1 && nl.indexOf('SingleChartComponent') === -1 ) ) {
          c.labels[l] = nl;
        }
      }
    } else {
      for (const d of c.datasets) {
        if (d.labelTranslated !== true) {
          d.label = this.getRessource(d.label);
          d.labelTranslated = true;
        }
        d.borderWidth = 1;
        d.backgroundColor = this.colors[colorIndex].b;
        d.borderColor = this.colors[colorIndex].f;
        colorIndex = colorIndex + 1;
        if (colorIndex === this.colors.length - 1) {
          colorIndex = 0;
        }
      }
    }
    const opt = c.Option === null || c.Option === undefined ? {} : JSON.parse(c.Option);
    opt['responsive'] = true;
    opt['maintainAspectRatio'] = false;
    const x = {
      data: {
        datasets: c.datasets,
        labels: c.labels
      },
      type: c.datasets[0].type,
      options: opt
    };
    this.createdChart = new Chart(context, x);
  }
}
